import { render, staticRenderFns } from "./ForgotPasswordCuritiba.vue?vue&type=template&id=1dd473db&scoped=true"
import script from "./ForgotPasswordCuritiba.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordCuritiba.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordCuritiba.vue?vue&type=style&index=0&id=1dd473db&prod&scoped=true&lang=css"
import style1 from "./ForgotPasswordCuritiba.vue?vue&type=style&index=1&id=1dd473db&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd473db",
  null
  
)

export default component.exports